import styled from 'styled-components';

import { displayDateWithTodayAndYesterdayPrefix } from 'utils/date';

import { EventInfo } from '../../../../domain';
import { TABLE_COLUMNS } from '../../constants';
import { Cell } from '../../../../components/table';

interface EventHistoryTimeCellProps {
  userEvent: EventInfo;
}

const StyledCell = styled(Cell)`
  && {
    white-space: nowrap;
  }
`;

export const EventHistoryTimeCell = ({ userEvent: { createdAt } }: EventHistoryTimeCellProps) => (
  <StyledCell data-test="time-cell" columnId={TABLE_COLUMNS.CREATED_AT}>
    {displayDateWithTodayAndYesterdayPrefix(createdAt)}
  </StyledCell>
);
